import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@app-i18n/i18n.module';
import { LandingsPageComponent } from '@app-pages/landings-page/landings-page.component';
import { ThanksPageComponent } from '@app-pages/thanks-page/thanks-page.component';
import { UploadPageComponent } from '@app-pages/upload-page/upload-page.component';
import { SharedModule } from '@app-shared/shared.module';
import { FileUploadModule } from 'ng2-file-upload';

const components = [
  LandingsPageComponent,
  UploadPageComponent,
  ThanksPageComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    FileUploadModule,
    I18nModule
  ],
  exports: components
})
export class PagesModule {}
